import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BehaviorSubject, interval, Subject, timer } from 'rxjs';
import { map, startWith, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.css'],
  animations: [
    trigger('slideInOut01', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('400ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('400ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ]),
    trigger('slideInOut02', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('900ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('900ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ])
  ]
})
export class HomePageComponent implements OnInit, AfterViewInit, OnDestroy {
  public buyWords: Array<string> = [
    'mattress',
    'carpet',
    'fridge',
    'table',
    'chairs',
    'gas cylinder',
  ]

  public sellWords = [
    'cooker',
    'bed frame',
    'pots',
    'wardrobe',
    'desk',
    'television',
  ]

  public isMobileMenuOpen = false;

  currentBuyWord = '';
  currentSellWord = '';

  private destroy$ = new Subject<void>();

  private buyWordIndex = 0;
  private sellWordIndex = 0;

  ngOnInit(): void {
    this.currentBuyWord = this.buyWords[0];
    this.currentSellWord = this.sellWords[0];

    interval(2000)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.buyWordIndex = (this.buyWordIndex + 1) % this.buyWords.length;
        this.sellWordIndex = (this.sellWordIndex + 1) % this.sellWords.length;

        this.currentBuyWord = '';
        this.currentSellWord = '';

        setTimeout(() => {
          this.currentBuyWord = this.buyWords[this.buyWordIndex];
        }, 400); // wait for leave animation

        setTimeout(() => {
          this.currentSellWord = this.sellWords[this.sellWordIndex];
        }, 900); // wait for leave animation
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {

  }

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  get fullYear(): number {
    return new Date()?.getFullYear();
  }

}
